import { render, staticRenderFns } from "./profil.panel.vue?vue&type=template&id=24927a18"
import script from "./profil.panel.vue?vue&type=script&lang=js"
export * from "./profil.panel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports